import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const THEME = {
    dark: '#1F2937',    // Sidebar background
    light: '#F3F4F6',   // Main bg
    active: '#374151',  // Active item bg
    accent: '#3B82F6',  // Blue accent
    text: '#D1D5DB',    // Text color
    white: '#FFFFFF'
};

const MENU_ITEMS = [
    { label: 'PANEL DE CONTROL', type: 'header' },
    { path: '/admin', label: '📊 Dashboard', icon: '🏠' },
    
    { label: 'OPERATIVO', type: 'header' },
    { path: '/admin/pedidos', label: '🚚 Pedidos', icon: '📦' },
    { path: '/admin/almacen', label: '🏭 Mi Bodega (Tueste)', icon: '⚙️' },
    { path: '/admin/inventario', label: '🌍 Inventario Global', icon: '🗺️' },
    { path: '/admin/clientes', label: '👥 Clientes', icon: '👤' },

    { label: 'FINANZAS', type: 'header' },
    { path: '/admin/pagos', label: '💰 Historial Pagos', icon: '💵' },
    
    { label: 'INTELIGENCIA', type: 'header' },
    { path: '/admin/analisis', label: 'Analisis de negocio', icon: '📆' },
    
    { label: 'Predicciones', type: 'header' },
    { path: '/admin/planeador', label: '📅 Planeador Abasto', icon: '📆' },
    { path: '/admin/predicciones', label: '🔮 Predicciones IA', icon: '🧠' },
    { path: '/admin/desviaciones', label: '🎯 Precisión / Error', icon: '📊' },

    { label: 'COMUNICACIÓN', type: 'header' },
    { path: '/admin/broadcast', label: '📢 Enviar Anuncio', icon: '📣' },
];

const AdminLayout = ({ children, title }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: THEME.light, fontFamily: 'sans-serif' }}>
            
            {/* SIDEBAR */}
            <aside style={{ width: 260, background: THEME.dark, color: THEME.text, display: 'flex', flexDirection: 'column', position: 'fixed', height: '100%', overflowY: 'auto' }}>
                <div style={{ padding: 20, borderBottom: '1px solid #374151' }}>
                    <h2 style={{ color: THEME.white, margin: 0, fontSize: 20 }}>☕ Admin Panel</h2>
                    <p style={{ fontSize: 12, opacity: 0.7, margin: '5px 0 0 0' }}>Gestión Xavana</p>
                </div>

                <nav style={{ flex: 1, padding: '15px 10px' }}>
                    {MENU_ITEMS.map((item, index) => {
                        if (item.type === 'header') {
                            return (
                                <div key={index} style={{ fontSize: 11, fontWeight: 'bold', color: '#6B7280', marginTop: 15, marginBottom: 5, paddingLeft: 10, letterSpacing: 1 }}>
                                    {item.label}
                                </div>
                            );
                        }

                        const isActive = location.pathname === item.path;
                        return (
                            <button
                                key={index}
                                onClick={() => navigate(item.path)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                                    padding: '10px 12px', marginBottom: 2, border: 'none', borderRadius: 6,
                                    background: isActive ? THEME.accent : 'transparent',
                                    color: isActive ? 'white' : THEME.text,
                                    cursor: 'pointer', fontSize: 14, textAlign: 'left', transition: '0.2s'
                                }}
                            >
                                <span>{item.icon}</span>
                                {item.label}
                            </button>
                        );
                    })}
                </nav>

                <div style={{ padding: 20, borderTop: '1px solid #374151' }}>
                    <button onClick={handleLogout} style={{ width: '100%', padding: 10, background: '#374151', color: '#F87171', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>
                        🚪 Cerrar Sesión
                    </button>
                </div>
            </aside>

            {/* MAIN CONTENT */}
            <main style={{ marginLeft: 260, flex: 1, padding: 30 }}>
                {title && <h1 style={{ marginTop: 0, marginBottom: 25, color: '#111827', fontSize: 28 }}>{title}</h1>}
                {children}
            </main>
        </div>
    );
};

export default AdminLayout;